import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import BaseAvatar from "@sprout/client-components/dist/Avatar";
import { useMemo, Fragment } from "react";
import { UserType } from "sprout-graphql";
import { Box, Flex, Text } from "sprout-ui-primitives";
import { media, themeGet } from "sprout-ui-theme";
import styled from "styled-components";
import getFullName from "@sprout/client-lib/dist/getFullName";
import prependHttp from "sprout-lib/dist/prependHttp";
import UrlLink from "@sprout/client-components/dist/UrlLink";
import { isNotNullish } from "sprout-lib";
import { Link } from "react-router-dom";
import ProfilePageUserHeaderTopButtons from "./ProfilePageUserHeaderTopButtons";
import ProfilePageUserHeaderBottomButtons from "./ProfilePageUserHeaderBottomButtons";
function pluralize(count, noun) {
    return `${count || 0} ${noun}${count === 1 ? "" : "s"}`;
}
const ProfilePageUserHeaderWrapper = styled(Box)`
  ${media.up("medium")} {
    background: ${themeGet("colors.white.100")};
    border-radius: 30px;
  }
`;
const ProfilePageUserHeaderContent = styled(Flex)`
  ${media.up("medium")} {
    padding: 40px 16px;
  }
`;
const Avatar = styled(BaseAvatar)`
  width: 80px;
  height: 80px;
`;
const ProfilePageUserHeader = (props)=>{
    const { user  } = props;
    const { website , bio , username , teamMemberships: teamMembershipsProp , type , followersCount , followingCount , memberCount ,  } = user;
    const [websiteUrl, websiteToDisplay] = useMemo(()=>{
        const empty = [
            null,
            null
        ];
        if (!website) return empty;
        try {
            const prependedWebsite = prependHttp(website);
            const { hostname  } = new URL(prependedWebsite);
            return [
                prependedWebsite,
                hostname
            ];
        } catch (e) {
            return empty;
        }
    }, [
        website
    ]);
    const teamMemberships = useMemo(()=>{
        return teamMembershipsProp.nodes.map(({ team  })=>team).filter(isNotNullish);
    }, [
        teamMembershipsProp.nodes
    ]);
    return /*#__PURE__*/ _jsxs(ProfilePageUserHeaderWrapper, {
        mb: 8,
        children: [
            /*#__PURE__*/ _jsx(ProfilePageUserHeaderTopButtons, {
                user: user
            }),
            /*#__PURE__*/ _jsxs(ProfilePageUserHeaderContent, {
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ _jsx(Avatar, {
                        user: user,
                        navigable: true,
                        size: 320
                    }),
                    /*#__PURE__*/ _jsx(Text, {
                        as: "h1",
                        mt: 1,
                        mb: 2,
                        textAlign: "center",
                        truncate: true,
                        fontSize: "34px",
                        fontWeight: "bold",
                        children: getFullName(user)
                    }),
                    /*#__PURE__*/ _jsxs(Text, {
                        as: "p",
                        textAlign: "center",
                        children: [
                            `@${username}`,
                            (bio || websiteUrl) && " -",
                            bio && ` ${bio}`,
                            websiteUrl && /*#__PURE__*/ _jsx(UrlLink, {
                                color: "blue.500",
                                fontSize: 1,
                                fontWeight: "bold",
                                url: websiteUrl,
                                children: ` ${websiteToDisplay}`
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Flex, {
                        mt: 2,
                        fontWeight: "bold",
                        children: [
                            type === UserType.Team && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        as: Link,
                                        to: `/${username}/members`,
                                        children: pluralize(memberCount, "member")
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        as: "span",
                                        mx: 0,
                                        children: "\u2022"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Text, {
                                as: Link,
                                to: `/${username}/followers`,
                                children: pluralize(followersCount, "follower")
                            }),
                            type === UserType.User && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        as: "span",
                                        mx: 0,
                                        children: "\u2022"
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        as: Link,
                                        to: `/${username}/following`,
                                        children: `${followingCount || 0} following`
                                    })
                                ]
                            })
                        ]
                    }),
                    teamMemberships.length > 0 && /*#__PURE__*/ _jsxs(Text, {
                        as: "p",
                        mt: 2,
                        color: "black.60",
                        textAlign: "center",
                        children: [
                            `Member of `,
                            teamMemberships.reduce((acc, currentValue, index)=>{
                                return [
                                    ...acc,
                                    /*#__PURE__*/ _jsxs(Fragment, {
                                        children: [
                                            index > 0 && ", ",
                                            /*#__PURE__*/ _jsx(Text, {
                                                as: Link,
                                                color: "blue.500",
                                                to: `/${currentValue.username}`,
                                                children: currentValue.firstName || currentValue.username
                                            })
                                        ]
                                    }, currentValue.username), 
                                ];
                            }, [])
                        ]
                    }),
                    /*#__PURE__*/ _jsx(ProfilePageUserHeaderBottomButtons, {
                        user: user
                    })
                ]
            })
        ]
    });
};
export default ProfilePageUserHeader;
